/**
 * <revamp-plan-select>
 * In-cart subscription frequency selector (Figma "DELIVERY EVERY 30 DAYS" dropdown).
 *
 * Works like the PDP plan picker: changing the <select> switches the line to the
 * chosen selling plan via POST /cart/change, then re-renders the drawer through
 * the theme's own cart:bundled-sections + cartUpdate pub/sub pipeline.
 *
 * Guarded so the AJAX section re-render (which re-inserts this script tag but does
 * not re-execute it) never throws "already defined".
 */
if (!customElements.get('revamp-plan-select')) {
  class RevampPlanSelect extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('select');
      if (this.select) this.select.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      // The theme's <cart-items> has a delegated 'change' listener that treats any
      // bubbling change as a line quantity update (updateQuantity(target.dataset.index,
      // target.value)). Our <select> has no data-index and its value is a selling-plan
      // id, so that produces a malformed POST /cart/change ({quantity:<planId>}, no line)
      // → 400 "Parameter Missing or Invalid". Stop it bubbling so only our own,
      // correct /cart/change runs.
      if (event) event.stopPropagation();

      if (this.getAttribute('aria-busy') === 'true') return;

      const line = this.dataset.line;
      const quantity = parseInt(this.dataset.quantity, 10) || 1;
      const sellingPlan = this.select.value;
      if (!line || !sellingPlan) return;
      if (typeof theme === 'undefined' || !theme.routes || !theme.pubsub) return;

      this.setAttribute('aria-busy', 'true');

      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } })
      );

      fetch(`${theme.routes.cart_change_url}`, {
        ...theme.utils.fetchConfig(),
        body: JSON.stringify({
          line,
          quantity,
          selling_plan: sellingPlan,
          sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status) {
            this.removeAttribute('aria-busy');
            return;
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState, line });
        })
        .catch(() => this.removeAttribute('aria-busy'));
    }
  }

  customElements.define('revamp-plan-select', RevampPlanSelect);
}
